import { HeaderWUT } from '@wix/form-fields/wut';

export default HeaderWUT;
